import logo from './logo.svg';
import './App.css';
import './style/app.min.css'
import React, { useEffect } from 'react';
import Navbar from './Components/Navbar';
import { Route, Routes } from 'react-router';
import Home from './Components/Home';
import About from './Components/About';
import  Media  from './Components/Media';
import  SignUp  from './Components/SignUp';
import ContactUs from './Components/ContactUs';
import DonationSignup from './Components/Charity/DonationSignup'
import FAQ from './Components/FAQ'
import RecyclerLogin from './Components/RecyclerLogin/RecyclerLogin'
import CustomerOrder from './Components/CustomerOrder';
import CustomerPortal from './Components/CustomerPortal/CustomerPortal.jsx';
import PasswordReset from './Components/PasswordReset';
import CharityVerification from './Components/Charity/CharityVerification';
import { SnackbarProvider } from 'notistack';
import ScrollToTop from "react-scroll-to-top";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { createTheme, ThemeProvider } from '@mui/material/styles';


const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });



const theme = createTheme({
    palette: {
        primary: createColor('#383838'),
        secondary: createColor('#98c800'),
        sipzeeGreen: createColor('#98c800'),
        sipzeeYellow: createColor('#ffb200'),
        sipzeeRed: createColor('#c02727'),
    },
});
/*https://bareynol.github.io/mui-theme-creator/#Menu*/


function App() {
    const [didLogin, setDidLogin] = React.useState(false);
    function loginChanged() {
        setDidLogin(new Date()); // force a rerender
    }


    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
                <div className="App">
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/Index.html" element={<Home />} />
                        <Route path="/Pickup" element={<Home eventType={'request'} />} />
                        <Route path="/Portal" element={<CustomerPortal LoginChanged={() => loginChanged()} />} />
                        <Route path="/About" element={<About />} />
                        <Route path="/Media" element={<Media />} />
                        <Route path="/ContactUs" element={<ContactUs />} />
                        <Route path="/SignUp" element={<SignUp />} />
                        <Route path="/FAQ" element={<FAQ />} />
                        <Route path="/PasswordReset" element={<PasswordReset /> } />
                        <Route path="/CharitySignup" element={<DonationSignup /> } />
                        <Route path="/Order" element={<CustomerOrder />} />
                        <Route path="/donationVerification" element={<CharityVerification />} />
                    </Routes>
                    <ScrollToTop smooth
                        component={<KeyboardArrowUpIcon sx={{ fontSize: 40 }} />}
                        color='var(--sipzee-gray)' style={{
                            right: '0px',
                            bottom: '40px',
                            opacity: '.6',
                            backgroundColor: 'var(--sipzee-yellow)',
                            paddingTop: '0px',
                            paddingLeft: '0px',
                            borderRadius: '50%'
                        }}

                    />
                </div>
            </SnackbarProvider>
        </ThemeProvider>
  );
}

export default App;
